module.exports = __webpack_public_path__ + "img/gov.311d50d9.jpg";